import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { history } from '../../views/App/history';
import { hasIncomingShareSession, isAuthedShareScreen } from '../../utils/native/incoming-share';
import IncomingShareDropLayer from '../IncomingShareDropLayer/IncomingShareDropLayer';
import IncomingShareDialog from './IncomingShareDialog';

const IncomingShareDialogGate = ({ authed }) => {
  const [pathname, setPathname] = useState(() => (history.location && history.location.pathname) || '');

  useEffect(() => history.listen(location => setPathname(location.pathname)), []);

  return (
    <>
      <IncomingShareDropLayer enabled={pathname === '/home'} />
      <IncomingShareDialog shortcutReady={Boolean(authed) && isAuthedShareScreen(pathname)} />
    </>
  );
};

export default connect(state => ({
  authed: hasIncomingShareSession(state)
}))(IncomingShareDialogGate);
